<template>
  <div style="padding-top: 10px;">
    <h1 style="font-size: 40px;text-align: center;margin-bottom: 25px;margin-top: 8px;">{{'欢迎你！'+user.name}}</h1>
    <el-descriptions title="个人中心" :column="2" size="40" border  :contentStyle="rowCenter" :labelStyle="rowCenter">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-custom"></i>
          账号
        </template>
        {{ user.account }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-phone"></i>
          名称
        </template>
        {{ user.name }}
      </el-descriptions-item>
     <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          性别
        </template>
        <el-tag :type="user.sex==='1'?'primary':'danger'" disable-transitions>
          <i :class="user.sex===1?'el-icon-male':'el-icon-female'"></i>
          {{ user.sex === 1 ? '男' : '女' }}
        </el-tag>
      </el-descriptions-item> -->
	  <el-descriptions-item>
	    <template slot="label">
	      <i class="el-icon-s-custom"></i>
	      昵称
	    </template>
	    {{ user.nickname }}
	  </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-ticket"></i>
          角色
        </template>
        <el-tag type="success" disable-transitions>
          {{ user.roleId === 0 ? '超级管理员' : (user.roleId == 1?'管理员':'普通用户') }}
        </el-tag>
      </el-descriptions-item>
    </el-descriptions>

    <DateUtils></DateUtils>
  </div>
</template>

<script>
import DateUtils from '../components/DateUtils'
export default {
  name: "Home",
  components:{DateUtils},
  data(){
    return{
      user:JSON.parse(sessionStorage.getItem('CurUser')),
      rowCenter:{
        "text-align":"center"
      }

    }
  },

}
</script>

<style scoped>

</style>